import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import {
  MuiThemeProvider,
  makeStyles,
  createMuiTheme,
} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { FILTER_BY } from '../../../shared/utils/constants';

const DateFilterType = ({ t, dateFilterType, onChangeFilter }) => {
  const useStyles = makeStyles({
    root: {
      color: '#646777',
      fontSize: '13px',
    },
    label: {
      fontSize: '13px',
    },
  });

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: '#646777',
      },
      secondary: {
        main: '#646777',
      },
    },
  });

  const classesStyle = useStyles();
  return (
    <MuiThemeProvider theme={theme}>
      <RadioGroup
        row
        value={dateFilterType}
        name="dateFilterType"
        onChange={({ target }) => onChangeFilter(target.value)}
      >
        <FormControlLabel
          value={FILTER_BY.DUE_DATE}
          classes={{
            root: classesStyle.root,
            label: classesStyle.label,
          }}
          control={<Radio />}
          label={t('general.expiration-date')}
          labelPlacement="end"
        />
        <FormControlLabel
          value={FILTER_BY.PAYDAY}
          classes={{
            root: classesStyle.root,
            label: classesStyle.label,
          }}
          control={<Radio />}
          label={t('general.settled-date')}
          labelPlacement="end"
        />
      </RadioGroup>
    </MuiThemeProvider>
  );
};

DateFilterType.propTypes = {
  t: PropTypes.func.isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  dateFilterType: PropTypes.string.isRequired,
};

export default withTranslation('common')(DateFilterType);
